import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchEdiRfidAuditRequestCreate = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createEdiRfidAuditRequest',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, {
    auditName: payload.params.auditName,
    executionMoment: payload.params.executionMoment,
    inboundImpcs: payload.params.inboundImpcs,
    outboundImpcs: payload.params.outboundImpcs,
    reportingEndDate: moment(payload.params.reportingEndDate).format('YYYY-MM-DD'),
    reportingStartDate: moment(payload.params.reportingStartDate).format('YYYY-MM-DD'),
    scheduleFrequency: payload.params.scheduleFrequency,
    scheduleType: payload.params.scheduleType,
    scheduledEndDate: moment(payload.params.scheduledEndDate).format('YYYY-MM-DD'),
    scheduledStartDate: moment(payload.params.scheduledStartDate).format('YYYY-MM-DD'),
  });
};

export default apiFetchEdiRfidAuditRequestCreate;
